'use client';
import { Navbar } from 'flowbite-react';
import Image from 'next/image';
import React, { useState } from 'react';
import MWSVG from './common/svg';
import Link from 'next/link';
import ThemeToggle from './ui/theme-toggle';

const UsaHeader = () => {
    const [show, setShow] = useState(false);

    return (
        <>
            <div className="top-[0px] z-[1031] bg-black py-2.5 px-1.5">
                <p className="mb-0 text-white text-center font-size-res fs-md font-bold">
                    USA Visit: <span className="gradient-text font-bold">7 May to 27 June 2026</span> Open for 1:1 leadership
                    conversations | Limited meeting slots{' '}
                </p>
            </div>
            <header className="sticky top-[45px] z-[1030] h-18 lg:h-20 border-b dark:border-b-0 border-light dark:bg-transparent dark:border-gray-600 flex flex-col justify-center">
                <Navbar className="!px-0 py-0 bg-transparent lg:h-auto dark:bg-transparent">
                    <div
                        id="navbarToggler"
                        className={show ? 'navbar-toggler cross lg:hidden' : 'navbar-toggler lg:hidden'}
                        onClick={() => setShow(!show)}
                    >
                        <span className="icon-bar top-bar"></span>
                        <span className="icon-bar middle-bar"></span>
                        <span className="icon-bar bottom-bar"></span>
                    </div>
                    <Link href="/" className="shine">
                        <Image
                            alt="Moweb"
                            src="/img/img-footer-logo@2x.webp"
                            height={45}
                            width={145}
                            loading="lazy"
                            className="logo dark:hidden logo-responsive"
                            quality={100}
                        />
                        <Image
                            alt="Moweb"
                            src="/img/img-header-logo.svg"
                            height={45}
                            width={145}
                            loading="lazy"
                            className="logo hidden dark:block logo-responsive"
                            quality={100}
                        />
                    </Link>
                    <div className="flex lg:order-2 items-center">
                        <div className="lg:hidden">
                            <span className="cursor-pointer link-footer" onClick={() => window.open('mailto:sales@moweb.com')}>
                                <MWSVG id="tabler-icon-mail" />
                            </span>
                        </div>
                        <ThemeToggle />
                        <Link href="#request-meeting" className="hidden lg:block btn btn-primary">
                            Schedule Meeting
                        </Link>
                        <p className="mb-0 ml-3">
                            <span
                                className="cursor-pointer link-whatsapp"
                                onClick={() => window.open('https://api.whatsapp.com/send/?phone=918123456521&text=Hello')}
                            >
                                <MWSVG id="ic-whatsapp-header" svgClassName="ic ic-49 dark:hidden" />
                                <Image
                                    alt="Moweb"
                                    src="/img/ic-whatsapp.svg"
                                    height={49}
                                    width={49}
                                    className="logo hidden dark:block"
                                    quality={100}
                                />
                            </span>
                        </p>
                    </div>
                    <Navbar.Collapse className={show ? 'navShow' : 'navHide'} id="navbarNav">
                        <li>
                            <a
                                href="#why-meet"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShow(false);

                                    const section = document.getElementById('why-meet');

                                    if (section) {
                                        section.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });
                                    }
                                }}
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                Why Meet
                            </a>
                        </li>
                        <li>
                            {/* <Link
                                onClick={() => setShow(false)}
                                href="#ai-capabilities"
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                AI Capabilities
                            </Link> */}
                            <a
                                href="#ai-capabilities"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShow(false);

                                    const section = document.getElementById('ai-capabilities');

                                    if (section) {
                                        section.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });
                                    }
                                }}
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                AI Capabilities
                            </a>
                        </li>
                        <li>
                            <a
                                href="#case-studies"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShow(false);

                                    const section = document.getElementById('case-studies');

                                    if (section) {
                                        section.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });
                                    }
                                }}
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                Case Studies
                            </a>
                        </li>
                        <li>
                            <a
                                href="#testimonials"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShow(false);

                                    const section = document.getElementById('testimonials');

                                    if (section) {
                                        section.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });
                                    }
                                }}
                                className="flex lg:block font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:!text-light dark:hover:text-white border-b dark:border-[#4c5773]"
                            >
                                Testimonials
                            </a>
                        </li>
                        <li>
                            <Link
                                onClick={() => setShow(false)}
                                href="#schedule-meeting"
                                className="flex lg:hidden font-medium lg:!border-0 leading-30 lg:leading-80 py-2.5 px-5 lg:py-0 lg:px-[14px] text-textcolor hover:text-blue dark:text-light dark:hover:text-white border-b border-gray-100 dark:border-gray-700"
                            >
                                Schedule Meeting
                            </Link>
                        </li>
                    </Navbar.Collapse>
                </Navbar>
            </header>
        </>
    );
};

export default UsaHeader;
